/**
 * @generated SignedSource<<4c6424e9f61504f87b7b554dad07e82b>>
 * @relayHash 0f67ef102a079e2d2c7343ff3cdda76d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f1d86033d6131197f175d38689d037bf2999cff013d5679fd453fc05e106a8a3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthJsmUpsellModal_GetStartStandardTrialUrlQuery } from './uiGrowthJsmUpsellModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthJsmUpsellModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f1d86033d6131197f175d38689d037bf2999cff013d5679fd453fc05e106a8a3",
    "metadata": {},
    "name": "uiGrowthJsmUpsellModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
